import styled from 'styled-components';
import { Column } from '@simplywallst/ui-core';

export const MetaRenderColumn = styled(Column)`
  min-height: ${({ theme }) => theme.x5space}rem;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;
